import React, { useState } from "react";
import DropDownBody from "./DropDownBody";
import DropDownBtn from "./DropDownBtn";
import "./DropDown.scss";

function DropDown() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <DropDownBtn open={open} openHandler={setOpen} />
      <DropDownBody openHandler={setOpen} open={open} />
    </>
  );
}

export default DropDown;
